module.exports = __webpack_public_path__ + "pdf/about.1e5eccf.pdf";